<template>
<div class="singlePost">
<div class="latestInfoEntry">
<p class="timestamp"> Tuesday, June 9th, 2020</p>
<h4>Black Lives Matter</h4>
<h4>Black Babies Matter</h4>
<br/>
<p>Eats on Feets stands with the Black community. We support their call for justice.
</p>
    <img class="blogImage blogImage-right" src="../../assets/BlackLivesMatter.jpg" />
<p>Eats on Feets especially acknowledges the need of Black communities for breastfeeding and breastfeeding support as well as the need for healing historical trauma so as to diminish racial and health disparities.
</p>
<p>Black lactating parents have unique barriers. Their generational breastfeeding history is complex and trauma-filled. Black women were wet nurses in slavery, being forced to breastfeed and nurture the slave owners' children, often to the detriment of their own children. This has created and continues to create barriers to breastfeeding and milksharing among Black families.
</p>
<p>Community-acquired breastmilk, when needed, can help diminish racial disparities in breastfeeding rates and can improve health outcomes. As is our purview, we will continue to advocate for equitable access to human milk for the health of babies. We are aware that representation matters. Eats on Feets represents families of color in memes and graphics on our network pages, and we highlight the disparities, as well as the celebrations, of BIPOC during Black Breastfeeding Week (8/25-31) and Native Breastfeeding week (8/9-15).
</p>
<p>We are committed to the continued education within our network on issues of equity, anti-racism, and reproductive justice, making resources available to all our volunteers.
</p>
</div>

</div>
</template>
<script>
export default {
  name: 'HowToRunAnEofPage'
}
</script>

<style lang="scss">
.references {
  font-size: .8em;
}
.repositionedThroughCssCauseIamTooLazyToEditTheImage {
  float:right;
  width: 101px;
  overflow: hidden;
  img {
    width: 218px;
    margin-left: -108px;
  }
}
</style>
